export default "__VITE_ASSET__DE_PsZ39__"